import React, { useMemo } from 'react';
import { Dots, InputAdornment, MenuItem, Select, TextField } from '~/UIKit';
import { Field } from 'formik';
import { useItemCreationMoney } from './useItemCreationMoney';
import { Error } from '../../../Error';
import { CHARCOAL_GREY, DARKER_GREY } from '~/Constants/Colors.constants';
import { selectClasses } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import { useTranslation } from 'react-i18next';
import { ItemCreationFieldValue } from '../../ItemCreation.models';

const useStyles = makeStyles({
  ItemCreationMoneyContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignContent: 'space-between',
    width: 'fit-content',
    alignItems: 'center',
  },
  ItemCreationMoneyNumber: {
    maxWidth: 100,
    marginLeft: 'auto',
  },
  ItemCreationMoneyText: {
    marginLeft: 4,
    minWidth: 'fit-content',
  },
  ItemCreationMoneySelector: {
    width: 80,
    marginLeft: 15,
    color: CHARCOAL_GREY,
    [`& .${selectClasses['select']}`]: {
      color: 'currentColor',
      border: `thin solid ${DARKER_GREY}`,
      borderRadius: 5,
      padding: '4px 24px 4px 5px',
    },
  },
});

export const ItemCreationMoney = ({
  name,
  value,
  placeholder,
  secondaryName,
  secondaryValue,
  setFieldValue,
}: {
  name: string;
  value: number;
  placeholder?: string;
  secondaryName: string;
  secondaryValue?: number;
  setFieldValue: ItemCreationFieldValue;
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const {
    currencyList,
    taxgroupList,
    currencyListLoading,
    taxgroupListLoading,
    error,
  } = useItemCreationMoney();
  const currencySymbol = currencyListLoading ? <Dots /> : currencyList[0]?.symbol;
  const filterTaxGroupList = useMemo(() => taxgroupList.filter((group) => group.default)[0]?.id, [
    taxgroupList,
  ]);
  const list = taxgroupListLoading ? (
    <Dots />
  ) : (
    !!taxgroupList.length && (
      <>
        <Field
          className={classes.ItemCreationMoneySelector}
          component={Select}
          name={secondaryName}
          value={secondaryValue || filterTaxGroupList}
          defaultValue={filterTaxGroupList}
          type="select"
          newDesign
          key={`slider-${2}`}
        >
          {taxgroupList.map((taxgroup) => (
            <MenuItem value={taxgroup.id} key={taxgroup.id}>
              {(taxgroup.percentage * 100).toPrecision(2)}%
            </MenuItem>
          ))}
        </Field>
        <div className={classes.ItemCreationMoneyText}>{t('form.field.VAT')}</div>
      </>
    )
  );
  const endAdornment = <InputAdornment position="end">{currencySymbol}</InputAdornment>;
  const handleBlurNumbers = () => {
    if (!value) {
      setFieldValue(name as string, 0);
    }
  };
  return (
    <div className={classes.ItemCreationMoneyContainer}>
      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Field
            className={classes.ItemCreationMoneyNumber}
            component={TextField}
            fullWidth
            name={name}
            placeholder={placeholder}
            type="number"
            onBlur={handleBlurNumbers}
            newDesign
            value={value}
            InputProps={{ endAdornment }}
          />
          {list}
        </>
      )}
    </div>
  );
};
